module.exports = __webpack_public_path__ + "static/media/ex.3a2e94d3.png";